
import { Route, Routes } from 'react-router-dom';

import { Error404 } from 'pages';
import ObserveMaintenance from 'pages/monitoring/equipment-observe';
import EquipmentObserveViewMaintenance from 'pages/monitoring/equipment-observe-view';


export default function MonitoringEquipmentObserveRoutes() {
    return (
        <Routes>
            <Route path="/*">
                <Route path="/*" element={ <ObserveMaintenance /> }/>
                
                <Route path=":id" element={ <EquipmentObserveViewMaintenance /> }/>
               
                <Route path="*" element={ <Error404/> }/>
            </Route>
        </Routes>
    );
}